import { Pickup } from '../../models/pickup';
import { PickupQuery } from '../../models/pickup-query';
import { AppState } from '../index';
import { createSelector } from '@ngrx/store';

export interface PickupTableState {
    query: PickupQuery;
    page: Pickup[];
    totalCount?: number;
    filteredCount?: number;
    busy: boolean;
    error: boolean;
    selection: string[];
}

export const selectPickupTableState = (state: AppState) => state.pickupTable;

export const selectPickupTableQuery = createSelector(selectPickupTableState,
    (state: PickupTableState) => state.query);

export const selectPickupTablePage = createSelector(selectPickupTableState,
    (state: PickupTableState) => state.page);

export const selectPickupTableBusy = createSelector(selectPickupTableState,
    (state: PickupTableState) => state.busy);

export const selectPickupTableCount = createSelector(selectPickupTableState,
    (state: PickupTableState) => state.totalCount);

export const selectPickupTableSelection = createSelector(selectPickupTableState,
    (state: PickupTableState) => state.selection);
